// extracted by mini-css-extract-plugin
export default {"fixedBottom":"index_fixedBottom_VHcW8","fixedBottomBox":"index_fixedBottomBox_xK5BK","fixedBottomPic1":"index_fixedBottomPic1_q-26o","fixedBottomPic2":"index_fixedBottomPic2_E96EO"};